module.exports = __webpack_public_path__ + "site/img/user.59a79a5f.svg";